/**
 * Shared types + labels for the lead-fact suggestion pipeline.
 * See ./suggestions.ts for the flow.
 */

import type { EMessageDirection } from 'src/services/api/messages/types';
import type { LeadFactKey } from 'src/services/api/leads/lead-facts';

export type IFactSuggestion = {
    key: LeadFactKey;
    value: string;
    label: string;
    /** 'rule' = detected client-side (used to drive the POST that persists it as a
     * pending row); 'stored' = a pending suggestion row read back from the backend.
     * Only 'stored' suggestions are displayed as chips and decided (PATCH by `id`). */
    source: 'rule' | 'stored';
    /** The backend row id; present only for `stored` suggestions. */
    id?: number;
};

/** Suggestion key -> human-readable label shown in the nudge. */
export const FACT_LABELS: Record<LeadFactKey, string> = {
    phone_number: 'Phone number',
    email: 'Email',
    pet_type: 'Pet',
    annual_income: 'Income',
    household_size: 'Household size',
    voucher_type: 'Voucher',
};

/** A conversation message reduced to what detection needs. */
export type SpeakerMessage = {
    direction: EMessageDirection;
    contents: string;
};

/** Fact keys the server-side LLM extracts (the rest are rule-detected client-side). */
export const LLM_FACT_KEYS: LeadFactKey[] = ['annual_income', 'household_size', 'voucher_type'];
